module.exports = __webpack_public_path__ + "static/primary-coaches-sm-e0b9c61c478bc450d5a26096ed848307.jpg";